export const medicationFrag = `
    id
    medicationCode
    medicationName
    customMedication
    serviceId
    customMedicationName
    from
    to
    packageTo
    active
    internalNote
    dosingNote
    prescribedBy {
        id
        name
        surname
        titleAfterName
        titleBeforeName
        email
    }
    dosingPeriod {
        days
        hours
        custom
    }
    dosing {
        morning
        forenoon
        noon
        afternoon
        evening
        night
        hours
    }    
`;
